import { Pipe, PipeTransform } from '@angular/core';
import { IUserInfo } from '../models/user.model';
import { Observable } from 'rxjs/Observable';
import { ClientData } from '../providers/client';

@Pipe({
    name: 'toCategoryname'
})

export class toCategorynamePipe implements PipeTransform {

    constructor(
        private clientProvider: ClientData
    ) { }

    transform(value: string, clientId: string): Observable<IUserInfo> {
        return this.clientProvider.getCategoryName(clientId, value)
    }
}


// WEBPACK FOOTER //
// ./src/pipes/toCategoryName.pipe.ts